import { getContractInstance } from './base'
import ABIXanaliaDex from './abi/xanalia-dex.json'
import { SupportedChainId, SupportedChains } from 'constants/chain'

export function ContractXanaliaDex(type: SupportedChains | SupportedChainId) {
  let address = undefined
  if (
    [
      SupportedChains.ethereum,
      SupportedChainId.MAINNET,
      SupportedChainId.RINKEBY,
    ].includes(type)
  ) {
    address = process.env.REACT_APP_RINKEBY_XANALIA_DEX_ADDRESS
  } else if (
    [
      SupportedChains.binance,
      SupportedChainId.BSC_MAINNET,
      SupportedChainId.BSC_TESTNET,
    ].includes(type)
  ) {
    address = process.env.REACT_APP_BINANCE_XANALIA_DEX_ADDRESS
  } else if (
    [
      SupportedChains.polygon,
      SupportedChainId.POLYGON,
      SupportedChainId.POLYGON_MUMBAI,
    ].includes(type)
  ) {
    address = process.env.REACT_APP_POLYGON_XANALIA_DEX_ADDRESS
  }
  return getContractInstance(ABIXanaliaDex, address)
}
